import { EDataLayerEventsLocal, EDataLayerPageTypeLocal } from '@shared/types'

export const dataLayerBaseData = {
  event: EDataLayerEventsLocal.MTS_DENGI_MAIN,
  pageType: EDataLayerPageTypeLocal.MAIN,
}
